import { useEffect, useState } from 'react';

/** Tablet and up. Below this a wide sheet-like table cannot be read. */
export const WIDE_SCREEN = '(min-width: 768px)';

/**
 * Whether there is room for a full worksheet table.
 *
 * Used to keep the Excel-wide Гераци report off phones, where the page shows
 * its cards, charts and drivers instead. Falls back to `true` where
 * `matchMedia` is unavailable (jsdom, SSR) so tests and non-browser renders
 * see the full page rather than silently losing it.
 */
export function useIsWideScreen(): boolean {
  const [wide, setWide] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return true;
    return window.matchMedia(WIDE_SCREEN).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const query = window.matchMedia(WIDE_SCREEN);
    const onChange = (event: MediaQueryListEvent) => setWide(event.matches);
    setWide(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return wide;
}
